import { cx } from '@orn/shared-web/utils/cx';

import Button from '../../components/Button';

export interface ISegmentedOption<T> {
  value: T;
  label: string;
}

interface ISegmentedButtonsProps<T> {
  /** Names the group for assistive tech; the options name themselves. */
  label: string;
  options: ReadonlyArray<ISegmentedOption<T>>;
  value: T;
  onChange: (value: T) => void;
}

/**
 * A row of joined buttons picking one of a few options, the picked one in the
 * accent. For a choice small enough to show whole, where a dropdown would hide
 * every option but the current one behind a click.
 */
function SegmentedButtons<T>({ label, options, value, onChange }: ISegmentedButtonsProps<T>) {
  return (
    <div role="group" aria-label={label} className="flex">
      {options.map((option, index) => {
        const isSelected = option.value === value;
        return (
          <Button
            key={option.label}
            size="xs"
            color={isSelected ? 'primary' : 'secondary'}
            aria-pressed={isSelected}
            onClick={() => onChange(option.value)}
            // Joined buttons share a border, so the hovered or focused one is lifted to show all of its own.
            className={cx('relative hover:z-10 focus-visible:z-10', index > 0 && '-ml-px', isSelected && 'z-10')}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}

export default SegmentedButtons;
